import * as React from "react";
import ArticleRepository from "../Repositories/ArticleRepository";
import ArticleTile from './ArticleTile';
import ArticleModel from '../Models/ArticleModel';
import LoadMoreBtn from './LoadMoreBtn';
import Filter from './Filter';

import Masonry from "../MasonryLayout/masonry";
import Tag from "../Models/Tag";

type Props = {
    fetchCount: number;
    filterByMainCategoryList: string;
    searchButtonText: string;
    searchBoxPlaceholderText: string;
    loadMoreButtonText: string;
    clearFiltersText: string;
    readMoreText: string;
    hideSearchField: string;
};

type State = {
    articles: ArticleModel[];
    currentPage: number;
    filters: Tag[];
    hasInitFilters: boolean;
};

export default class TileList extends React.Component<Props, State> {
    articleRepository: ArticleRepository;
    masonry: Masonry;
    initFilters: any;
    constructor(props: Props) {
        super(props);
        this.articleRepository = new ArticleRepository();
        this.masonry = new Masonry();
        let filters = new Array<Tag>();
        let hasInitFilters = false;
        this.initFilters = [];
        if(this.props.filterByMainCategoryList && this.props.filterByMainCategoryList != ""){
            var filterByList = this.props.filterByMainCategoryList.split(",");
            for(var i = 0; i < filterByList.length; i++) {
                var tag = filterByList[i];
                var name = tag.split("_");
                this.initFilters.push({key: name[0], value: name[1]});
                filters.push({key: name[0], value: name[1]});
            }
            hasInitFilters = true;
        }

        this.state = {
            articles: new Array<ArticleModel>(),
            currentPage: 1,
            filters,
            hasInitFilters
        };
        this.loadMoreArticles = this.loadMoreArticles.bind(this);
        this.search = this.search.bind(this);
        this.setArticles = this.setArticles.bind(this);
        this.tagsOnChanged = this.tagsOnChanged.bind(this);
        this.allTagsRemoved = this.allTagsRemoved.bind(this);
    }

    public search() {
        this.setState({ currentPage: 1 });
        this.getArticles(1);
    }

    public tagsOnChanged(whitelisttags, e) {
        if (e.target.value !== "") {
            let tags = JSON.parse(e.target.value);
            var currentTags = [];
            for (var i = 0; i < tags.length; i ++) {
                for(var j = 0; j < whitelisttags.length; j ++) {
                    var tag = tags[i];
                    var keyValuePairTag = whitelisttags[j];
                    if (tag.value == keyValuePairTag.Value) {
                        currentTags.push( { Key: keyValuePairTag.Key, Value: keyValuePairTag.Value});
                        break;
                    }
                }
            }
            console.log(currentTags);
            this.setState({ filters: currentTags });
        } else {
            this.setState({ filters: [] });
        }
    }

    public allTagsRemoved() {
        this.setState({ filters: [] });
    }

    public setArticles(data: Array<ArticleModel>) {
        if (this.state.currentPage > 1) {
            const articles = this.state.articles;
            for (var article of data) {
                articles.push(article);
            }
            this.setState({ articles: articles });
        } else {
            this.setState({ articles: data });
        }
    };

    public componentDidMount() {
        this.getArticles(1);
    }

    public componentDidUpdate() {
        this.masonry.waitForImages();
        window.addEventListener("resize", this.masonry.resizeAllGridItems);
    }

    public render() {
        const hideSearchField = this.props.hideSearchField == "true" ? false : true;
        return (
                <div>
                    {hideSearchField &&
                    <Filter
                        searchButtonText={this.props.searchButtonText}
                        searchBoxPlaceholderText={this.props.searchBoxPlaceholderText}
                        clearFiltersText={this.props.clearFiltersText}
                        onSearch={this.search}
                        tagsOnChanged={this.tagsOnChanged}
                        allTagsRemoved={this.allTagsRemoved} /> }
                <div className="article-list">
                    {this.state.articles && this.state.articles.map((item, i) => {
                        return <ArticleTile
                            key={i}
                            image={item.image}
                            title={item.title}
                            description={item.description}
                            pageUrl={item.pageUrl}
                            date={item.date}
                            id={item.id}
                            type={item.type}
                            readMoreText={this.props.readMoreText}
                            author={item.author}
                            isBlog={item.isBlog}
                        />
                    })}
                </div>
                <LoadMoreBtn loadMoreButtonText={this.props.loadMoreButtonText} onClick={this.loadMoreArticles} />
            </div>
        );
    }

    private getArticles(pageNumber: number) {
        this.articleRepository.search(this.props.fetchCount, this.state.filters, pageNumber, this.setArticles, this.props.hideSearchField);
    }

    private loadMoreArticles() {
        const pageNumber = this.state.currentPage + 1;
        this.setState({ currentPage: pageNumber });
        this.getArticles(pageNumber);
    }
}
